
import React, { useEffect, useState } from "react";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import CandidateLayout from "../commonlayouts/candidatelayout";
import Axios from "axios";
import { GetCandidateById, GetJobRoles, GetCourseInfo,GetJobPosts,AddCandidateSubmissions,SaveCandidateRecordedAudio ,GetListOfUsersWithAdminByEmployeeID, GetListOfVendorsByEmployeeID,GetCandidateSubmission,GetDocumentTypes,DeleteBlob,GetCandidateByGuid, UpdateCandidateSubmissions, DeleteCandidateSubmission } from "../apiconstants/constants";
import { json, Link, useLocation,useNavigate } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from 'react-bootstrap/Modal';
import LoadingSpinner from "../helpers/loadingspinner";
import { useCountry } from "../contexts/countrycodecontext.js";
import { useForm } from "react-hook-form";
import { Accordion, Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import mammoth from "mammoth";
import axios from "axios";
import Select from 'react-select';
import ReactQuill from "react-quill";
import DOMPurify from "dompurify"; // optional but recommended
import SubmissionView from "./addeditcandidate/viewsubmission";
import Spinner from "react-bootstrap/Spinner";
import { extractResumeDetails } from "../utils/resumeExtraction.js";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}


const ViewCandidateDetailsByCandidateGUid = () => {
    let query = useQuery();
    const guid = query.get("guid");
    let Guid="";
 const [isExtractingResume, setIsExtractingResume] = useState(false);
  const [showExtractModal, setShowExtractModal] = useState(false);
  const [extractedData, setExtractedData] = useState(null);
  const [selectedFields, setSelectedFields] = useState({
  skills: true,
  experience: true,
  profilesummary: true,
});
const toggleField = (field) => {
  setSelectedFields((prev) => ({
    ...prev,
    [field]: !prev[field],
  }));
};
const toggleSelectAll = (checked) => {
  setSelectedFields({
    skills: checked,
    experience: checked,
    profilesummary: checked,
  });
};
const FieldRow = ({ label, value, checked, onChange }) => (
  <div className="d-flex align-items-start mb-3">
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      style={{ marginRight: 12, marginTop: 4 }}
    />
    <div>
      <div style={{ fontWeight: 600 }}>{label}</div>
      <div
        style={{
          fontSize: 13,
          color: "#555",
          whiteSpace: "pre-line",
        }}
      >
        {Array.isArray(value)
          ? value.join(", ")
          : value || "—"}
      </div>
    </div>
  </div>
);
const sanitize = (value) => {
  return value !== null && value != undefined && value !== "undefined" && value !== "null" ? value : "";
};
const applySelectedExtractedData = () => {
  if (!extractedData) return;

  if (selectedFields.skills)
    setValue("technicalSkill", extractedData.skills?.join(", ") || "");

  if (selectedFields.experience){
     const exp = sanitize(extractedData.experience || "");

const yearMatch = exp.match(/(\d+)\s*year/i);
const monthMatch = exp.match(/(\d+)\s*month/i);

const y = yearMatch ? yearMatch[1] : "";
const m = monthMatch ? monthMatch[1] : "";

handleExperienceChange(y, m);
  }
 
  if (selectedFields.profilesummary)
    setValue("ProfileSummery", extractedData.profilesummary || "");

  // ✅ CLOSE BOTH MODALS
  setShowExtractModal(false);
  setShowModal(false);
  setSelectedDocType(null);
  setExtractedData(null);

  Swal.fire({
    icon: "success",
    title: "Applied",
    text: "Selected resume details applied successfully",
    timer: 1500,
    showConfirmButton: false,
  });
    setSelectedFields({
  skills: true,
  experience: true,
  profilesummary: true,
});
};  
const [fileName, setFileName] = useState(null);


const handleResumeUploadWithChoice = async (event) => {
 

  const file = event.target.files[0];
  if (!file) return;

  const { isConfirmed, isDenied } = await Swal.fire({
    title: "Resume Upload",
    text: "Do you want to extract details from this resume?",
    icon: "question",
    showDenyButton: true,
    confirmButtonText: "Extract & Autofill",
    denyButtonText: "Upload Only",
  });

  const sanitizedName = file.name.replace(/[^a-zA-Z0-9.\-_]/g, "_");
  const renamedFile = new File([file], sanitizedName, { type: file.type });

  setUploadedFiles(prev => ({ ...prev, Resume: renamedFile }));
  setFileName(sanitizedName);
  if (isDenied){
    setShowExtractModal(false)
     return;
  }

  try {
setShowExtractModal(true); 
setIsExtractingResume(true);
  const extracted = await extractResumeDetails({
    file: renamedFile,
    token: localStorage.getItem("jwtToken"),
  });

  if (!extracted) throw new Error("Empty extraction");

  setExtractedData(extracted);
setIsExtractingResume(false);
  console.log("Extracted Data:", extracted);
  // 👈 open selection modal

} catch (err) {
  Swal.fire("Error", "Resume extraction failed", "error");
} finally {
  setIsExtractingResume(false); // 👈 STOP spinner
}

};
    const {selectedCountry} = useCountry();
    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const roleID = localStorage.getItem("roleID")
    const [submissions, setSubmissions] = useState([]);
const [showSubmissionForm, setShowSubmissionForm] = useState(false);
const [isEditing, setIsEditing] = useState(false);
const [isViewMode, setIsViewMode] = useState(false);
const [isAddMode, setIsAddMode] = useState(false);
const [selectedJobTitleId, setSelectedJobTitleId] = useState("");
const [usersList, setUsersList] = useState([]);
const [submittedBy, setSubmittedBy] = useState("");
    const [candidateType,setCandidateType] = useState([
          {candidateTypeID:"Internal Bench",typeName:"Internal Bench"},
          {candidateTypeID:"C2C",typeName:"C2C"},
          {candidateTypeID:"W2",typeName:"W2"},
        {candidateTypeID:"1099",typeName:"1099"}]);
        const docKeyMap = {
  "Resume": "Resume",
  "RTR_PDF": "RTR_PDF",
  "Resume_Insights_Pdf": "Resume_Insights_Pdf",
  "Others": "Others",
  "Visa Copy": "visaCopy",
  "Driving Licence": "drivingLicence",
  "Passport": "passport",
  "I-94": "i94",
};


 const [skills, setSkills] = useState([
    { Skill: "", YearsOfExp: "", Rating: "" },
  ]);
  const isEmptySkill = (skill) =>
  !skill?.Skill && !skill?.YearsOfExp && !skill?.Rating;
  const [showAssessmentModal, setShowAssessmentModal] = useState(false);
  const [assessmentMode, setAssessmentMode] = useState(""); // "link" or "file"
  const [assessmentFile, setAssessmentFile] = useState(null); 
const [audioValue, setAudioValue] = useState("");
const [audioFile, setAudioFile] = useState("");
const token = localStorage.getItem("jwtToken");

  
const navigate = useNavigate();
// Fetch Submissions List
const fetchSubmissions = async () => {
  try {
    const url = GetCandidateByGuid.APIURL
    const payload = { guid: guid };
    const res = await Axios.post(url, payload,
          { headers: { Authorization: `Bearer ${token}` } }  
    );
    setSubmissions(res.data?.submissions || []);
  } catch (err) {
    console.error("Error fetching submissions:", err);
  }
};
  const GetUsersList = async () => {
     setIsLoading(true);
 
     const GetapiUrl =  GetListOfUsersWithAdminByEmployeeID.APIURL + `?EmployeeGuid=${Guid}`;
 
   await  Axios.get(GetapiUrl,
        { headers: { Authorization: `Bearer ${token}` } }
   )
       .then((result) => {
         setIsLoading(false);
 const filteredusers = result.data?.filter(user =>
   user.countryMappings?.includes(selectedCountry)
 );
        setUsersList(filteredusers || []);
       }).catch((error) => {
         console.log("Error" + error);
       });
   };
// Fetch Single Submission by ID
const fetchSubmissionById = async (submissionId) => {
  try {
  
    if (!submissionId) {
      console.error("❌ submissionId is undefined. Cannot fetch submission details.");
      return;
    }

    const url = `${GetCandidateSubmission.APIURL}?submissionGuid=${submissionId}`;
    console.log("Fetching submission details from:", url);

    const res = await Axios.get(url,
      { headers: { Authorization: `Bearer ${token}` } }

    ); // ✅ added await
    const data = res.data || {};
    setSubmissionData(data); // ✅ store for reuse in edit submit

 if (res.data?.experience) {
  const exp = res.data.experience.match(/(\d+)?\s*Years?\s*(\d+)?\s*Months?/i);

  const y = exp?.[1] || "";
  const m = exp?.[2] || "";

  setYears(y);
  setMonths(m);

  let expText = "";
  if (y && !m) expText = `${y} Years`;
  if (!y && m) expText = `${m} Months`;
  if (y && m) expText = `${y} Years ${m} Months`;

  setValue("experience", expText);
}

    console.log("Fetched submission details:", data);
 setCurrentSubmissionGuid(data.submissionGuid);
  setSelectedJobTitleId(data.jobTitleID || "");
setSubmittedBy(data.submittedBy || "");
setValue("SubmittedBy", data.submittedBy || "");
setValue("Comments", data.comments || "");
console.log("candidateType set to:", data.candidateType || "");
setValue("CandidateType", data.candidateType || "");
    reset({
payRate: data.payRate
  ? data.payRate.replace(/rs\.?/i, "").replace(/\$/g, "").replace(/[^\d]/g, "")
  : "",
BillRate: data.billRate
  ? data.billRate.replace(/rs\.?/i, "").replace(/\$/g, "").replace(/[^\d]/g, "")
  : "",

      jobRole: data.jobRole|| "",
      VendorGuid: data.vendorGuid || "",
      jobPost: data.jobTitleID || "",   
      clientStatus: data.clientStatus || "Submitted",
      technicalSkill: data.technicalSkill || "",
      workMode: data.workMode || "",
      ProfileSummery: data.profileSummery || "",
      SubmittedBy:  data.SubmittedBy || "",     
      Comments: data.comments || "",
     CandidateType:data.candidateType || "",
     AvailabilityToJoin: data.availabilityToJoin || data.AvailabilityToJoin || "",
     AvailabilityToInterview: data.availabilityToInterview || data.AvailabilityToInterview || "",
     WillingToRelocate:
     data.willingToRelocate?.toString(),
     Tworefrencesfromrecentproject: data.tworefrencesfromrecentproject || data.tworefrencesfromrecentproject || "",
    documents: [],
    });
    // Reset dropdowns first
setYears("");
setMonths("");

// Parse after reset
if (data.experience) {
  const exp = data.experience.trim();

  let y = "";
  let m = "";

  const yearMatch = exp.match(/(\d+)\s*Years?/i);
  const monthMatch = exp.match(/(\d+)\s*Months?/i);

  if (yearMatch) y = yearMatch[1];
  if (monthMatch) m = monthMatch[1];

  setYears(y);
  setMonths(m);

  let expText = "";
  if (y && !m) expText = `${y} Years`;
  else if (!y && m) expText = `${m} Months`;
  else if (y && m) expText = `${y} Years ${m} Months`;

  setValue("experience", expText);
}

    // ✅ After reset({...})
if (data.skillMetrics) {
  try {
    const parsed = JSON.parse(data.skillMetrics);
    setSkills(
      Array.isArray(parsed) && parsed.length > 0
        ? parsed
        : [{ Skill: "", YearsOfExp: "", Rating: "" }]
    );
  } catch {
    setSkills([{ Skill: "", YearsOfExp: "", Rating: "" }]);
  }
} else {
  setSkills([{ Skill: "", YearsOfExp: "", Rating: "" }]);
}


// ✅ Handle custom assessment link/file display
if (data.customAssessmentLink) {
  setAssessmentMode("link");
  setValue("customAssessmentLink", data.customAssessmentLink);
} else if (data.customAssessmentFile) {
  setAssessmentMode("file");
  setAssessmentFile(data.customAssessmentFile);
} else {
  setAssessmentMode("");
  setAssessmentFile(null);
}

// 👇 Trigger dependent dropdown once values are reset
if (data.jobRole && data.vendorGuid) {
  await fetchJobPosts(data.jobRole, data.vendorGuid);
}
setUploadedFiles({

  // 🧾 Resume

  Resume:

    data.fileUrl && data.fileUrl.trim() !== ""

      ? data.fileUrl

      : data.resume && data.resume.trim() !== ""

      ? data.resume

      : null,
 
  // 📄 RTR

  RTR_PDF:

    data.rtR_PDFDoc && data.rtR_PDFDoc.trim() !== ""

      ? data.rtR_PDFDoc

      : data.rtR_PDF && data.rtR_PDF.trim() !== ""

      ? data.rtR_PDF

      : null,
 
  // 📘 Resume Insights

  Resume_Insights_Pdf:

    data.resume_Insights_Pdfdoc && data.resume_Insights_Pdfdoc.trim() !== ""

      ? data.resume_Insights_Pdfdoc

      : data.resume_Insights_Pdf && data.resume_Insights_Pdf.trim() !== ""

      ? data.resume_Insights_Pdf

      : null,
 
  // 📂 Others

  Others:

    data.othersDoc && data.othersDoc.trim() !== ""

      ? data.othersDoc

      : data.others && data.others.trim() !== ""

      ? data.others

      : null,
 
  // 🪪 Visa Copy

  visaCopy:

    data.visaCopyUrl && data.visaCopyUrl.trim() !== ""

      ? data.visaCopyUrl

      : data.visaCopy && data.visaCopy.trim() !== ""

      ? data.visaCopy

      : null,
 
  // 🚗 Driving Licence

  drivingLicence:

    data.drivingLicenceUrl && data.drivingLicenceUrl.trim() !== ""

      ? data.drivingLicenceUrl

      : data.drivingLicence && data.drivingLicence.trim() !== ""

      ? data.drivingLicence

      : null,
 
  // 🛂 Passport

  passport:

    data.passportURL && data.passportURL.trim() !== ""

      ? data.passportURL

      : data.passport && data.passport.trim() !== ""

      ? data.passport

      : null,
 
  // 📑 I-94

  i94:

    data.i94File && data.i94File.trim() !== ""

      ? data.i94File

      : data.i94 && data.i94.trim() !== ""

      ? data.i94

      : null,

});

setUploadedFiles(prev => ({
  Resume:
    prev.Resume === "__removed__"
      ? "__removed__"
      : (data.fileUrl || data.resume || null),

  RTR_PDF:
    prev.RTR_PDF === "__removed__"
      ? "__removed__"
      : (data.rtR_PDFDoc || data.rtR_PDF || null),

  Resume_Insights_Pdf:
    prev.Resume_Insights_Pdf === "__removed__"
      ? "__removed__"
      : (data.resume_Insights_Pdfdoc || data.resume_Insights_Pdf || null),

  Others:
    prev.Others === "__removed__"
      ? "__removed__"
      : (data.othersDoc || data.others || null),

  visaCopy:
    prev.visaCopy === "__removed__"
      ? "__removed__"
      : (data.visaCopyUrl || data.visaCopy || null),

  drivingLicence:
    prev.drivingLicence === "__removed__"
      ? "__removed__"
      : (data.drivingLicenceUrl || data.drivingLicence || null),

  passport:
    prev.passport === "__removed__"
      ? "__removed__"
      : (data.passportURL || data.passport || null),

  i94:
    prev.i94 === "__removed__"
      ? "__removed__"
      : (data.i94File || data.i94 || null),
}));
 



  } catch (err) {
    console.error("Error fetching submission:", err);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to fetch submission details. Please try again.",
    });
  }
};



    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= userguid
    }
    const [candidateDetails, setCandidateDetails] = useState(null);
    const [jobRoles, setJobRoles] = useState([]);
    const [qualifications, setQualifications] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState({ title: "", url: "" });
const { register, handleSubmit, reset, watch, setValue, formState: { errors } } = useForm({
  defaultValues: {
    payRate: candidateDetails?.payRate || "",
    jobRole: candidateDetails?.jobRole || "",
    vendor: "",
    jobTitle: "",
    experience: candidateDetails?.experience || "",
    clientStatus: "",
    documents: []
  }
});
  const [years, setYears] = useState("");
  const [months, setMonths] = useState("");
  const [vendorData, setVendorData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState(null);
  const [documents,SetDocuments] =useState([{}]);
    const [uploadedFiles, setUploadedFiles] = useState({});
      const [jobPosts, setJobPosts] = useState([]);    
      const [showModal1, setShowModal1] = useState(false);
       const jobTitleOptions = jobPosts.map(job => ({
        value: job.jobPostID,
        label: `${job.title} - ${job.clientName}`,
        jobDescription: job.jobDescription ,// Store job description for later use
        billRate: job.billRate,
      }));
  
const saveCandidateAudio = async (candidateGuid, candidateName, audioFile, audioValue) => {
  const audioForm = new FormData();
  audioForm.append("Guid", candidateGuid);
  audioForm.append("CandidateName", candidateName);
  audioForm.append("Audio", audioFile);
  audioForm.append("AudioUrl", audioFile?.name || "");
  audioForm.append("FileId", audioValue || "");

  try {
    await Axios.post(SaveCandidateRecordedAudio.APIURL, audioForm, {
      headers: { "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`
       },
    });
  } catch (err) {
    console.error("Save audio failed:", err);
  }
};

  const documentLabels = {
    FileUrl: "Resume",
    VisaCopyUrl: "Visa Copy",
    DrivingLicenceUrl: "Driving Licence",
    PassportURL: "Passport",
    I94File: "I-94",
     RTR_PDFDoc:"RTR_PDF",
    Resume_Insights_Pdfdoc:"Resume_Insights_Pdf",
    OthersDoc:"Others"
  };
   const [workmode, setWorkMode] = useState([
      { statusID: "1", statusName: "Work from Home" },
      { statusID: "2", statusName: "Work from Office" },
      { statusID: "3", statusName: "Hybrid" }])
      const [submissionData, setSubmissionData] = useState({});

useEffect(() => {
  if (candidateDetails) {
    reset({
      payRate: candidateDetails.payRate || "",
      jobRole: candidateDetails.jobRole || "",
      experience: candidateDetails.experience || "",
      vendor: "",
      jobTitle: "",
      clientStatus: "",
      documents: []
    });
  }
}, [candidateDetails]);
useEffect(() => {
  if (isEditing && submissionData) {
    // Populate fields
    reset({
      technicalSkill: submissionData.technicalSkill || "",
      vendorName: submissionData.vendorName || "",
      clientStatus: submissionData.clientStatus || "",
      payRate: submissionData.payRate || "",
      billRate: submissionData.billRate || "",
    });
  }
}, [submissionData, isEditing, reset]);
  const handleExperienceChange = (y, m) => {
    setYears(y);
    setMonths(m);
    const expText = `${y ? y + " Years" : ""} ${m ? m + " Months" : ""}`.trim();
    setValue("experience", expText); // store combined value in RHF
  };
    const fetchJobRoles = async () => {
    const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
        try {
            const response = await Axios.get(getApiUrl);
            setJobRoles(response.data);
        } catch (error) {
            console.error("Error fetching job roles", error);
        }
    };
      const handleShowModal1 = async (docTypeKey, file) => {
      if (!file) return;
    
      let fileName = "";
      let blobUrl = "";
    
      if (file instanceof File) {
        fileName = file.name.toLowerCase();
        blobUrl = URL.createObjectURL(file);
      } else if (typeof file === "string") {
        fileName = file.split("/").pop().toLowerCase();
        blobUrl = file;
      } else {
        console.error("Unknown file type");
        return;
      }
    
     if (fileName.endsWith(".docx")) {
      if (file instanceof File) {
        try {
          const arrayBuffer = await file.arrayBuffer();
          const { value } = await mammoth.convertToHtml({ arrayBuffer });
          setModalContent({
            title: documentLabels[docTypeKey] || docTypeKey,
            html: value,
            url: null,
            file: file,
          });
        } catch (error) {
          console.error("DOCX preview error", error);
          setModalContent({
            title: documentLabels[docTypeKey] || docTypeKey,
            html: "<p>Failed to render DOCX preview.</p>",
            url: null,
            file: file,
          });
        }
      } else if (typeof file === "string") {
        // ✅ Set the URL so Office viewer iframe can use it
        setModalContent({
          title: documentLabels[docTypeKey] || docTypeKey,
          html: null,
          url: file, // ✅ not null anymore
          file: null,
        });
      } else {
        console.error("Invalid DOCX file type");
        setModalContent({
          title: documentLabels[docTypeKey] || docTypeKey,
          html: "<p>Cannot preview this DOCX file.</p>",
          url: null,
          file: null,
        });
      }
    }
    else {
      setModalContent({
        title: documentLabels[docTypeKey] || docTypeKey,
        html: null,
        url: file,
        file: null,
      });
    }
    
      setShowModal1(true);
    };
    
    const handleCloseModal1 = () => {
      setShowModal1(false);
    };
   
const handleRemoveFile = async (label) => {
  const key = docKeyMap[label];   // 🔥 convert UI label → actual uploadedFiles key

  const confirmDelete = await Swal.fire({
    title: "Are you sure?",
    text: "Do you want to remove this document?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, remove it!",
  });

  if (!confirmDelete.isConfirmed) return;

  const updated = { ...uploadedFiles };
  updated[key] = "__removed__";   // 🔥 mark as removed

  setUploadedFiles(updated);

  Swal.fire({
    icon: "success",
    title: "Removed!",
    timer: 1500,
    showConfirmButton: false,
  });
};


 const fetchcodocumenttypes= async()=>
    {
      const GetapiUrl=GetDocumentTypes.APIURL;
      const fetchJSON = async () => {
        const response = await fetch(GetapiUrl);
        let json = await response.json();
        SetDocuments(json);
      }
      fetchJSON();
  }
    const fetchQualifications = async () => {
        const getApiUrl = GetCourseInfo.APIURL;
        try {
            const response = await Axios.get(getApiUrl);
            setQualifications(response.data);
        } catch (error) {
            console.error("Error fetching qualifications", error);
        }
    };

    const GetCandidateDetails = async () => {
        const GetapiUrl = GetCandidateById.APIURL;
        const params = { guid: guid };

         try {
    const result = await Axios.post(GetapiUrl, params);
    setCandidateDetails(result.data);

    // ✅ place your setUploadedFiles HERE (inside try block, right after setCandidateDetails)
    setUploadedFiles({
      FileUrl: result.data?.fileUrl || null,
      VisaCopyUrl: result.data?.visaCopyUrl || null,
      DrivingLicenceUrl: result.data?.drivingLicenceUrl || null,
      PassportURL: result.data?.passportURL || null,
      I94File: result.data?.i94File || null,
      RTR_PDFDoc: result.data?.rtR_PDFDoc || null,
      Resume_Insights_Pdfdoc: result.data?.resume_Insights_Pdfdoc || null,
      OthersDoc: result.data?.othersDoc || null
    });

  } catch (error) {
    console.error("Error fetching candidate details:", error);
  }
    };

  const handleShowModal = (title, url) => {
  setModalContent({ title, url });
  setShowModal(true);
};

    const handleCloseModal = () => {
        setShowModal(false);
    };
const GetVendorsList = async() => {
  setIsLoading(true);

  const GetapiUrl = GetListOfVendorsByEmployeeID.APIURL + `?UserGuid=${Guid}&CountryID=${selectedCountry}`;

 await Axios.get(GetapiUrl)
    .then((result) => {
      setIsLoading(false);

      setVendorData(result.data);
    }).catch((error) => {
      console.log("Error" + error);
    });
};
console.log("vendorData", vendorData);
useEffect(() => {
  const initializeData = async () => {
    try {
      await fetchJobRoles();
      await fetchQualifications();
      await GetCandidateDetails();
      await GetVendorsList();
      await fetchcodocumenttypes();
      await fetchSubmissions();
      await GetUsersList();
    } catch (error) {
      console.error("Error initializing data:", error);
    }
  };

  initializeData();
}, [selectedCountry]);


   // Watch form fields FIRST
const selectedJobRole = watch("jobRole");
const selectedVendorGuid = watch("VendorGuid");

// Then use them safely inside useEffect
useEffect(() => {
  if (selectedJobRole && selectedVendorGuid) {
    fetchJobPosts(parseInt(selectedJobRole), selectedVendorGuid);
  } else {
    setJobPosts([]); // clear if either is not selected
  }
}, [selectedJobRole, selectedVendorGuid]);


const fetchJobPosts = async (jobRoleId, vendorGuid) => {
  setIsLoading(true);
  try {
    const response = await Axios.get(`${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
// Filter based on selected Job Role and Vendor (client)
    const filteredPosts = response.data.filter((post) =>
      post.jobRoleID == jobRoleId && post.vGuid == vendorGuid&&
       post.status=="Active"
    );
        console.log(filteredPosts)

    setJobPosts(filteredPosts);
  } catch (error) {
    console.error("Error fetching job posts", error);
  } finally {
    setIsLoading(false);
  }
};
   
    
    const getExperienceText = (experience) => {
        if (!experience) return '';
        return experience?.toLowerCase().includes('years') ? experience : `${experience} years`;
      };
      
    const getJobRoleName = (id) => {
        const jobRole = jobRoles.find(role => role.jobRoleId == id);
        return jobRole ? jobRole.jobRole : "";
    };

    const getQualificationName = (id) => {
        const qualification = qualifications.find(q => q.qualificationID == id);
        return qualification ? qualification.courseName : "";
    };

const renderAttachment = (url, file, html) => {
  if (html) {
    return (
      <div
        style={{ maxHeight: "500px", overflowY: "auto" }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  // ✅ Handle both File objects and string URLs safely
  let name = "";
  if (file && file.name) {
    name = file.name.toLowerCase();
  } else if (typeof url === "string") {
    name = url.split("/").pop()?.toLowerCase() || "";
  } else {
    console.warn("Invalid URL or file type passed to renderAttachment:", url);
    return <div>File not found or unsupported format.</div>;
  }

  // ✅ Fallback check
  if (!url && !file) {
    return <div>File not found.</div>;
  }

  const fileUrl =
    typeof url === "string"
      ? url
      : file
      ? URL.createObjectURL(file)
      : null;

  if (!fileUrl) {
    return <div>File not found.</div>;
  }

  // ✅ PDF
  if (name.endsWith(".pdf")) {
    return (
      <iframe
        src={fileUrl}
        style={{ width: "100%", height: "500px", border: "none" }}
        title="PDF Preview"
      />
    );
  }

  // ✅ Image
  if (name.endsWith(".jpg") || name.endsWith(".jpeg") || name.endsWith(".png")) {
    return <img src={fileUrl} alt="preview" style={{ maxWidth: "100%" }} />;
  }

  // ✅ HTML
  if (name.endsWith(".html") || name.endsWith(".htm")) {
    return (
      <iframe
        src={fileUrl}
        title="HTML Preview"
        style={{ width: "100%", height: "500px", border: "none" }}
      />
    );
  }

  // ✅ DOCX
  if (name.endsWith(".docx")) {
    if (typeof fileUrl === "string" && fileUrl.startsWith("https")) {
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`}
          title="DOCX Preview"
          style={{ width: "100%", height: "500px", border: "none" }}
        />
      );
    } else {
      return (
        <div>
          <p>
            DOCX preview not supported for local files.{" "}
            <a href={fileUrl} target="_blank" rel="noreferrer">
              Download
            </a>
          </p>
        </div>
      );
    }
  }

  return (
    <div>
      <p>
        Preview not supported for this file type.{" "}
        <a href={fileUrl} target="_blank" rel="noreferrer">
          Download
        </a>
      </p>
    </div>
  );
};

const safeValue = (value) => 
  (value === null || value === undefined || value === "null" || value === "undefined") 
    ? "" 
    : value;

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    };
const handleDownload = (url) => {
  const fileExtension = url.split('.').pop().toLowerCase();

  const link = document.createElement("a");
  link.href = url;

   if (["pdf", "html", "htm"].includes(fileExtension)) {
    // open in a new tab instead of downloading
    link.target = "_blank";
  } else {
    // force download for other file types
    link.setAttribute("download", "");
  }

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  const handleDeleteSubmission = async (submissionId) => {

    try {
      setIsLoading(true);
      const result = await Axios.delete(`${DeleteCandidateSubmission.APIURL}?submissionGuid=${submissionId}`,
        {
              headers:{
                  Authorization: `Bearer ${token}`
              }
            }
      );
      
      if (result.data === 'Deleted successfully.') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Deleted successfully',
          showConfirmButton: false,
          timer: 2000,
        });
        fetchSubmissions();
        setIsLoading(false);
        setShowModal(false);
      }
    } catch (error) {
      console.log("Error", error);
      setIsLoading(false);
    }
  };



const [currentSubmissionGuid, setCurrentSubmissionGuid] = useState(null);
const onSubmit = async (data,e) => {
  try {
    e.preventDefault();
    setIsLoading(true);
if (isExtractingResume) {
  Swal.fire({
    icon: "info",
    title: "Please wait",
    text: "Resume extraction is in progress",
  });
  return;
}
    // 🧩 Prepare multipart form data
    const formData = new FormData();
const finalJobTitleId = data.jobPost || selectedJobTitleId;
    // Basic required fields
   if (isEditing && currentSubmissionGuid) {
  formData.append("SubmissionGuid", currentSubmissionGuid);
} else {
  formData.append("SubmissionGuid", '00000000-0000-0000-0000-000000000000');
}
// Empty as per spec
    formData.append("CandidateGuid", guid);
    formData.append("CandidateID", candidateDetails?.candidatesID || "");
    formData.append("JobRoleID", data.jobRole || "");
    formData.append("VendorGuid", data.VendorGuid || "");
    formData.append("TechnicalSkill", data.technicalSkill || "");
    formData.append("Experience", data.experience || "");
    formData.append("WorkMode", data.workMode || "");
    formData.append("ProfileSummery", data.ProfileSummery || "");
    formData.append("JobTitleID", finalJobTitleId || "");
    formData.append("ClientStatus", data.clientStatus || "New");
 formData.append("SubmittedBy", data.SubmittedBy || submittedBy || email);
formData.append("SkillMetrics", data.SkillMetrics || JSON.stringify(skills || [])); // JSON string expected
formData.append("AvailabilityToInterview", data.AvailabilityToInterview || "");
formData.append("AvailabilityToJoin", data.AvailabilityToJoin || "");
// WillingToRelocate may be boolean or "Yes"/"No" — adapt if backend expects boolean
formData.append("WillingToRelocate", data.WillingToRelocate);
formData.append("TwoReferencesFromRecentProject", data.Tworefrencesfromrecentproject || data.TwoReferencesFromRecentProject || "");
formData.append("CustomAssessmentLink", data.customAssessmentLink || "");
formData.append("comments", data.Comments || "");
formData.append("CandidateType",data.CandidateType ||"C2C");

// inside onSubmit before appending PayRate and BillRate
const formatRate = (value, isUSD) => {
  if (!value) return "";

  const trimmedValue = value.toString().trim();

  // ✅ Detect if already has Rs, $, INR, or USD
  const hasCurrency = /(\$|rs\.?|inr|usd)/i.test(trimmedValue);
  if (hasCurrency) return trimmedValue;

  // ✅ Add appropriate prefix
  return isUSD ? `$${trimmedValue}` : `Rs.${trimmedValue}`;
};


// ✅ use it as before
formData.append("PayRate", formatRate(data.payRate, selectedCountry == 2));
formData.append("BillRate", formatRate(data.BillRate, selectedCountry == 2));

    formData.append("CreatedBy", email);

  // 🧾 Handle uploaded documents (send actual file names)
// ✅ Enhanced version — keeps previously fetched docs if user doesn't upload new ones
const appendFilePair = (labelKey, binaryKey, localKey) => {
  let file = uploadedFiles[localKey];

  // 🔥 1️⃣ If user removed this file
  if (file === "__removed__") {
    formData.append(labelKey, "");
    formData.append(binaryKey, "");
    return;
  }

  // 2️⃣ NEW Upload
  if (file instanceof File) {
    formData.append(labelKey, file.name);
    formData.append(binaryKey, file, file.name);
    return;
  }

  // 3️⃣ Existing URL (not removed)
  if (typeof file === "string" && file.trim() !== "") {
    const filename = file.split("/").pop();
    formData.append(labelKey, filename);
    formData.append(binaryKey, file);
    return;
  }

  // 4️⃣ In EDIT MODE → fallback to previous submission files
  if (isEditing && submissionData) {
    const previousFiles = {
      Resume: submissionData.fileUrl,
      RTR_PDF: submissionData.rtR_PDFdoc,
      Resume_Insights_Pdf: submissionData.resume_Insights_Pdfdoc,
      Others: submissionData.othersDoc,
      VisaCopy: submissionData.visaCopyUrl,
      DrivingLicence: submissionData.drivingLicenceUrl,
      Passport: submissionData.passportURL,
      I94: submissionData.i94File,
    };

    const existingUrl = previousFiles[labelKey];

    if (existingUrl && existingUrl.trim() !== "") {
      const filename = existingUrl.split("/").pop();
      formData.append(labelKey, filename);
      formData.append(binaryKey, existingUrl);
      return;
    }
  }

  // 5️⃣ Nothing present → empty
  formData.append(labelKey, "");
  formData.append(binaryKey, "");
};

// Match keys to API field names
// appendFilePair("Resume", "FileUrl", "Resume");
// appendFilePair("RTR_PDF", "RTR_PDFDoc", "RTR_PDF");
// appendFilePair("Resume_Insights_Pdf", "Resume_Insights_Pdfdoc", "Resume_Insights_Pdf");
// appendFilePair("Others", "OthersDoc", "Others");
// appendFilePair("VisaCopy", "VisaCopyUrl", "visaCopy");
// appendFilePair("DrivingLicence", "DrivingLicenceUrl", "drivingLicence");
// appendFilePair("Passport", "PassportURL", "passport");
// appendFilePair("I94", "I94File", "i94");

// appendFilePair("Resume", "FileUrl", "Resume");
// appendFilePair("RTR_PDF", "RTR_PDFDoc", "RTR_PDF");
// appendFilePair("Resume_Insights_Pdf", "Resume_Insights_Pdfdoc", "Resume_Insights_Pdf");
// appendFilePair("Others", "OthersDoc", "Others");
// appendFilePair("VisaCopy", "VisaCopyUrl", "Visa Copy");
// appendFilePair("DrivingLicence", "DrivingLicenceUrl", "Driving Licence");
// appendFilePair("Passport", "PassportURL", "Passport");
// appendFilePair("I94", "I94File", "I-94");

appendFilePair("Resume", "FileUrl", "Resume");
appendFilePair("RTR_PDF", "RTR_PDFDoc", "RTR_PDF");
appendFilePair("Resume_Insights_Pdf", "Resume_Insights_Pdfdoc", "Resume_Insights_Pdf");
appendFilePair("Others", "OthersDoc", "Others");
appendFilePair("VisaCopy", "VisaCopyUrl", docKeyMap["Visa Copy"]);
appendFilePair("DrivingLicence", "DrivingLicenceUrl", docKeyMap["Driving Licence"]);
appendFilePair("Passport", "PassportURL", docKeyMap["Passport"]);
appendFilePair("I94", "I94File", docKeyMap["I-94"]);


const apiurl = isEditing ? UpdateCandidateSubmissions.APIURL : AddCandidateSubmissions.APIURL
    // ✅ Send to API
    const response = await axios.post(
      apiurl,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data",
                     Authorization: `Bearer ${token}`
         },

      }
    );
if (assessmentMode === "file" && assessmentFile) {
  await saveCandidateAudio(
    currentSubmissionGuid,
    candidateDetails?.fullName,
    assessmentFile,
    audioValue
  );
}
    // ✅ Success handling
    if (response.data.message == "Submission Created Sucessfully" ) {
      setShowSubmissionForm(false);
        fetchSubmissions();
      await Swal.fire({
        title: "✅ Success!",
        text: "Submission created successfully.",
        icon: "success",
        confirmButtonColor: "#28a745",
      });
      reset();
      setUploadedFiles({});
      setSelectedDocType("");
    } 
      else if (response.data.message == "Submission Updated Sucessfully" ) {
      setShowSubmissionForm(false);
        fetchSubmissions();
      await Swal.fire({
        title: "✅ Success!",
        text: "Submission updated successfully.",
        icon: "success",
        confirmButtonColor: "#28a745",
      })
      ;
      reset();
      setUploadedFiles({});
      setSelectedDocType("");
    } 
   else if (response.data.message == "This candidate is already marked as Internal Bench." ) {
      setShowSubmissionForm(false);
        fetchSubmissions();
      await Swal.fire({
        title: "Warning",
        text: "This candidate is already marked as Internal Bench.",
        icon: "warning",
        confirmButtonColor: "#28a745",
      })
      ;
      reset();
      setUploadedFiles({});
      setSelectedDocType("");
    } 
    else if (response.data.message == "Record not created" ) {
      await Swal.fire({
        title: "⚠️ Error",
        text: "Something went wrong while saving the submission.",
        icon: "error",
        confirmButtonColor: "#dc3545",
      });
    }
  } catch (error) {
    console.error("❌ API Error:", error);
    await Swal.fire({
      title: "❌ Error",
      text: error.response?.data?.message || "Failed to submit candidate data.",
      icon: "error",
      confirmButtonColor: "#dc3545",
    });
  } finally {
    setIsLoading(false);
  }
};
  const handleChange = (index, field, value) => {
    const updated = [...skills];
    updated[index][field] = value;
    setSkills(updated);

    // Keep API value updated as stringified JSON
    setValue("SkillMetrics", JSON.stringify(updated));
  };
  const handleAdd = () => {
    setSkills([...skills, { Skill: "", YearsOfExp: "", Rating: "" }]);
  };
  const handleDelete = (index) => {
    const updated = skills.filter((_, i) => i !== index);
    setSkills(updated);
    setValue("SkillMetrics", JSON.stringify(updated));
  };
    return (
      
        <ConsultantLayout>
          <style>
  {`.custom-modal-dialog {
  max-width: 90vw !important; /* 90% of screen width */
}

/* Modal content box */
.custom-modal-dialog .modal-content {
  height: 90vh; /* 90% of screen height */
  display: flex;
  flex-direction: column;
}

/* Header and footer stay fixed */
.custom-modal-dialog .modal-header,
.custom-modal-dialog .modal-footer {
  flex-shrink: 0;
}

/* 🟢 Scrollable body section */
.custom-modal-body {
  flex-grow: 1;
  overflow-y: auto;
  max-height: calc(90vh - 120px); /* Leaves space for header/footer */
  padding-right: 12px; /* Avoid scrollbar overlap */
}
`}
          </style>
            {candidateDetails ? (
                <div className="container-fluid">
                    <CandidateLayout title="Candidate Details" candidateGuid={guid} fullName= {candidateDetails?.fullName} email={candidateDetails?.email}/>
                    <hr />
                    
                    <Accordion defaultActiveKey="0" className="mt-1">
<Accordion.Item eventKey="0">
    <Accordion.Header>
      <i className="fa fa-user text-info mr-2"></i> Candidate Details
    </Accordion.Header>
    <Accordion.Body>
 <div className="card shadow-lg mt-2 pl-5 pr-5 pt-2 " style={{ border: "none" }}>
                        <div className="row mt-2">
                            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-fullName">Full Name</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-user icons"></i> {candidateDetails.fullName}</p>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Email</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-envelope icons"></i> {candidateDetails.email}</p>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-mobileNumber">Mobile Number</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-phone icons"></i> {candidateDetails.mobileNumber}</p>
                                </OverlayTrigger>
                   
                                               
                               {candidateDetails.gender !=null &&   candidateDetails.gender !== "null" &&
                               (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-gender">Gender</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-venus-mars icons"></i> {candidateDetails.gender}</p>
                                </OverlayTrigger>)}
 
                              {candidateDetails.address !=null &&   candidateDetails.address  !== "null" &&
                              ( <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-address">Address</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-map-marker icons"></i> {candidateDetails.address}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.dob  != null &&   candidateDetails.dob  !== "null" &&
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-dob">Date of Birth</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-birthday-cake icons"></i> {candidateDetails.dob}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.maritalStatus != null &&   candidateDetails.maritalStatus !== "null" &&  
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-maritalStatus">Marital Status</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-heart icons"></i> {capitalizeFirstLetter(candidateDetails.maritalStatus)}</p>
                                </OverlayTrigger>)}
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-experience">Experience</Tooltip>}>
        <p className="text-para"><i className="fa fa-briefcase icons"></i> {getExperienceText(candidateDetails.experience)}</p>
      </OverlayTrigger>
      {/* {candidateDetails.preferLocation != null &&   candidateDetails.preferLocation !== "null" &&  
                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-preferLocation">Country</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-map icons"></i>     {candidateDetails.preferLocation === "1" ? "India" : "United States"}</p>
                                </OverlayTrigger>} */}
                                {candidateDetails.technicalSkill != null &&   candidateDetails.technicalSkill !== "null" &&  
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-technicalSkill">Technical Skill</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-cogs icons"></i> {candidateDetails.technicalSkill}</p>
                                </OverlayTrigger>}
                                  {candidateDetails.highestEducation !=null &&   candidateDetails.highestEducation !== "null" &&
                               (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-gender">Highest Education</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-graduation-cap icons"></i> {candidateDetails.highestEducation}</p>
                                </OverlayTrigger>)}
                             
                                    {/* {candidateDetails.workAuthorizationandValidity !== null && candidateDetails.workAuthorizationandValidity!== "null" &&
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-technicalSkill">Work Authorization and Validity</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-cogs icons"></i> {candidateDetails.workAuthorizationandValidity}</p>
                                </OverlayTrigger>)} */}
                                {selectedCountry == 2 &&
  candidateDetails.workAuthorizationandValidity !== null &&
  candidateDetails.workAuthorizationandValidity !== "null" && (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip id="tooltip-technicalSkill">
          Work Authorization and Validity
        </Tooltip>
      }
    >
      <p className="text-para">
        <i className="fa fa-cogs icons"></i> {candidateDetails.workAuthorizationandValidity}
      </p>
    </OverlayTrigger>
)}
 
  {candidateDetails.candidateType  !== null && candidateDetails.candidateType !== "null"  && (      
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Candidate Type</Tooltip>}>
                                    <p className="text-para"><i className="fas fa-hourglass-half icons"></i> {safeValue(candidateDetails.candidateType)}</p>
                                </OverlayTrigger>)}
 
                                {candidateDetails.employerName !== null && candidateDetails.employerName!== "null" &&
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-technicalSkill">Employer Name</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-cogs icons"></i> {candidateDetails.employerName}</p>
                                </OverlayTrigger>}
                               
                                {candidateDetails.ssn !== null && candidateDetails.ssn !== "null" &&
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">SSN</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-building icons"></i> {candidateDetails.ssn}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.passportNo !== null && candidateDetails.passportNo !== "null" &&
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Passport Number</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-id-card icons"></i> {candidateDetails.passportNo}</p>
                                </OverlayTrigger>)}
     
 
                 </div>
                            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                     
                                {candidateDetails.createdBy  !== null && candidateDetails.createdBy !== "null"  && (      
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">CreatedBy</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-user icons"></i> {candidateDetails.createdBy}</p>
                                </OverlayTrigger>)}
                             
  {candidateDetails.priority !== null && candidateDetails.priority !== "null" && (
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip-workMode">Priority</Tooltip>}
  >
    <p className="text-para">
      <i className="fa fa-building icons"></i>    {candidateDetails.priority }
    </p>
  </OverlayTrigger>
)}
 
{candidateDetails.profileSummery !== null && candidateDetails.profileSummery !== "null" && (
<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-profileSummery">Profile Summary</Tooltip>}>
    <p className="text-para"><i className="fa fa-info-circle icons"></i> {candidateDetails.profileSummery}</p>
</OverlayTrigger>)}
{(candidateDetails.jobRole !== null && candidateDetails.jobRole !== 0 && candidateDetails.jobRole !== "null" ) && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobRole">Job Role</Tooltip>}>
        <p className="text-para"><i className="fa fa-briefcase icons"></i> {getJobRoleName(candidateDetails.jobRole)}</p>
    </OverlayTrigger>
)}
 
{(candidateDetails.qualificationID !== null && candidateDetails.qualificationID !== 0 && candidateDetails.qualificationID !== "null") && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-qualification">Qualification</Tooltip>}>
        <p className="text-para"><i className="fa fa-graduation-cap icons"></i> {getQualificationName(candidateDetails.qualificationID)}</p>
    </OverlayTrigger>
)}
 
{candidateDetails.linkedInUrl !== null && candidateDetails.linkedInUrl !== "null" && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-qualification">LinkedIn Url</Tooltip>}>
        <a
            href={candidateDetails.linkedInUrl?.startsWith('http') ? candidateDetails.linkedInUrl : `https://${candidateDetails.linkedInUrl}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            <p className="text-para">
                <i className="fa fa-graduation-cap icons mr-1"></i>
                {candidateDetails.linkedInUrl}
            </p>
        </a>
    </OverlayTrigger>
)}
 
 
                                {(candidateDetails.resume || candidateDetails.visaCopy || candidateDetails.drivingLicence) && (
  <h2 className="" style={{ color: "#00a7ac", marginLeft: '10px', marginBottom: '2', marginTop: '0' }}>
    Attachments
  </h2>
)}
 
 
{candidateDetails.resume!==null  && candidateDetails.resume  !== "null"&& (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-resume">Resume</Tooltip>}>
    <p className="text-para">
      <a
        href="#"
        style={{ fontSize: 18 }}
        onClick={() => handleShowModal('Resume', candidateDetails.fileUrl)}
      >
        <i className="fa fa-file-alt icons"></i> View Resume
      </a>
      &nbsp;|&nbsp;
   <a
  href="#"
  style={{ fontSize: 18 }}
  onClick={(e) => {
    e.preventDefault();
    handleDownload(candidateDetails.fileUrl, candidateDetails.fullName, "Resume");
  }}
>
  <i className="fa fa-download icons"></i> Download Resume
</a>
 
 
 
    </p>
  </OverlayTrigger>
)}
                               <Modal show={showModal} onHide={handleCloseModal} size="lg">
                                    <Modal.Header closeButton>
                                        <Modal.Title>{modalContent.title}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {renderAttachment(modalContent.url)}
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>
                    </div>  
                     </Accordion.Body>
  </Accordion.Item>
 
    <Accordion.Item eventKey="2">
  <Accordion.Header>
    <i className="fa fa-edit text-success mr-2"></i> Candidate Submissions
  </Accordion.Header>
  <Accordion.Body>
    <div className="d-flex justify-content-between align-items-center mb-3">
    <h5 className="text-secondary mb-0">Submissions List</h5>
     
      <button
  className="btn btn-sm btn-primary" onClick={async () => {
    
      setIsAddMode(true);  
  setIsViewMode(false);
  setIsEditing(false);
  setShowSubmissionForm(true);
if (submissions.length > 0) {
    // 🔥 Sort by date DESC — newest first
    const sorted = [...submissions].sort(
      (a, b) => new Date(b.submittedDate) - new Date(a.submittedDate)
    );

    const latest = sorted[0]; // NEWEST submission

    await fetchSubmissionById(latest.submissionGuid);
    return;
  }
  // 1️⃣ If there are existing submissions → load the most recent one
  if (submissions.length > 0) {
    const lastSubmission = submissions[submissions.length - 1];

    // Fetch the full details of latest submission
    await fetchSubmissionById(lastSubmission.submissionGuid);

    return; // stop here → form gets filled by fetchSubmissionById()
  }

  // 2️⃣ If no previous submission → use candidateDetails to prefill
  reset({
    payRate: candidateDetails?.payRate || "",
    jobRole: candidateDetails?.jobRole || "",
    technicalSkill: candidateDetails?.technicalSkill || "",
    ProfileSummery: candidateDetails?.profileSummery || "",
    SubmittedBy: email,
    Comments: "",
  });

  // Reset experience
  setYears("");
  setMonths("");

  // Only resume should be preloaded
  setUploadedFiles({
    Resume: candidateDetails?.fileUrl || candidateDetails?.resume || null,
  });
setSkills([{ Skill: "", YearsOfExp: "", Rating: "" }]);
setValue(
  "SkillMetrics",
  JSON.stringify([{ Skill: "", YearsOfExp: "", Rating: "" }])
);

  // Extract experience if exists
  if (candidateDetails?.experience) {
    const exp = candidateDetails.experience.trim();
    const y = exp.match(/(\d+)\s*Years?/i)?.[1] || "";
    const m = exp.match(/(\d+)\s*Months?/i)?.[1] || "";

    setYears(y);
    setMonths(m);

    let expText = "";
    if (y && m) expText = `${y} Years ${m} Months`;
    else if (y) expText = `${y} Years`;
    else if (m) expText = `${m} Months`;

    setValue("experience", expText);

  }
}}>
 <i className="fa fa-plus mr-1"></i> Add Submission
      </button> 
 
    </div>

    {/* Submissions Table */}
    {submissions.length > 0 ? (
      <div className="table-responsive">
    <table  className="table" style={{fontSize: "12px", wordWrap: "break-word",  }}>
          <thead className="table-light">
            <tr>
              
              <th>Vendor</th>
              <th>Vendor Email</th>
              <th>Job Title</th>
              <th>Job Role</th>
              <th>Candidate Type</th>
              <th>Client Status</th>
               <th>Bill Rate</th>
              <th>Pay Rate</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {submissions.map((s, i) => (
              <tr key={i}>
            <td>{s.vendorName}</td>
            <td>{s.vendorEmail}</td>
                <td>{s.jobTitle}</td>
                <td>{s.jobRole}</td>
              <td>{s.candidateType}</td>
                <td>{s.clientStatus}</td>
                 <td>{s.billRate}</td>
                <td>{s.payRate}</td>
                <td>
                 <button
  className="btn btn-sm btn-outline-success mr-2"
  onClick={async () => {
    setIsEditing(true);
    setIsAddMode(false);
    setIsViewMode(false);
    setUploadedFiles({});
    await fetchJobRoles(); // ensure job roles loaded first
    await fetchSubmissionById(s.submissionGuid); // ✅ wait for data
    setShowSubmissionForm(true); // ✅ open after form reset
  }}
>
  <i className="fa fa-edit"></i>
</button>

            <button
  className="btn btn-sm btn-outline-secondary mr-2"
  onClick={async () => {
    setIsEditing(false);
    setIsAddMode(false);     // 🔥🔥 prevents Add logic
    setIsViewMode(true);
    setUploadedFiles({});
    await fetchSubmissionById(s.submissionGuid);
    setShowSubmissionForm(true);
  }}
>
  <i className="fa fa-eye"></i>
</button>


                  <button
    className="btn btn-sm btn-outline-primary mr-2"
     onClick={() =>
    navigate("/Employer/ShareDetailstoVendor", {
      state: {
        vendorGuid: s.vendorGuid,
        vendorEmail: s.vendorEmail,
        vendorName: s.vendorName,
        vendorCompanyName: s.vendorCompanyName,
        jobTitleID: s.jobTitleID,
        jobDescription: s.jobDescription,
        jobRole: s.jobRole,
        jobLocation: s.jobLocation,
        jobMode: s.jobMode,
        endClientName: s.endClientName,
        jobTitle: s.jobTitle,
        candidateGuid: guid, // optional, if available
        submissionId:s.submissionGuid
      },
    })
  }
  >
    <i className="fa fa-share"></i>
  </button>
       <button
    className="btn btn-sm btn-outline-danger"
     onClick={()=>handleDeleteSubmission(s.submissionGuid)
  }
  >
    <i className="fa fa-trash " ></i>
  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <p className="text-muted">No submissions found.</p>
    )}

    {/* Modal for Add/Edit Form */}
 <Modal
  show={showSubmissionForm}
  onHide={() => setShowSubmissionForm(false)}
  size="xl"
  centered
  dialogClassName="custom-modal-dialog"
>
      <Modal.Header closeButton>
        <Modal.Title>
           {isViewMode
    ? "View Submission"
    : isEditing
    ? "Edit Submission"
    : "Add New Submission"}
        </Modal.Title>
      </Modal.Header>
   <Modal.Body className="custom-modal-body">
   {isLoading ? (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
      <LoadingSpinner />
    </div>
  ) : isViewMode ? (
    <SubmissionView data={submissionData}  submissionData={submissionData}
  handleShowModal={handleShowModal}
  handleDownload={handleDownload}/>
 ) : (
  <>
    {/* 🔥 Resume Extraction Modal (Add + Edit ONLY) */}
  
    {/* 🔽 EXISTING FORM — DO NOT CHANGE */}
    <Form onSubmit={handleSubmit(onSubmit)}>

    
    <div className="row">
      {/* ✅ Row 1: Vendor, Job Role, Job Title */}
     <div className="col-md-6 mb-3">
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip">Select Vendor</Tooltip>}
  >
    <div>
      <Select
        options={vendorData.map(v => ({
          value: v.vGuid,
          label: `${v.vendorName} - ${v.vendorCompanyName}`,
        }))}
        value={
          vendorData
            .map(v => ({
              value: v.vGuid,
              label: `${v.vendorName} - ${v.vendorCompanyName}`,
            }))
            .find(opt => opt.value === watch("VendorGuid")) || null
        }
        onChange={(selected) => setValue("VendorGuid", selected?.value || "")}
        placeholder="Select Vendor"
        isDisabled={isViewMode}
        styles={{
          control: base => ({
            ...base,
            borderRadius: 15,
            height: 50,
            fontSize: 12,
          }),
        }}
      />
      {errors.VendorGuid && (
        <span className="text-danger">Vendor is required</span>
      )}
    </div>
  </OverlayTrigger>
    </div>


     <div className="col-md-6 mb-3">
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip">Select Job Role</Tooltip>}
  >
    <div>
      <Select
        options={jobRoles.map(j => ({
          value: j.jobRoleId,
          label: j.jobRole,
        }))}
        value={
          jobRoles
            .map(j => ({
              value: j.jobRoleId,
              label: j.jobRole,
            }))
            .find(opt => opt.value === watch("jobRole")) || null
        }
        onChange={(selected) => setValue("jobRole", selected?.value || "")}
        placeholder="Select Job Role"
        isDisabled={isViewMode}
        styles={{
          control: base => ({
            ...base,
            borderRadius: 15,
            height: 50,
            fontSize: 12,
          }),
        }}
      />
    </div>
  </OverlayTrigger>
    </div>
 </div>
 <div className="row">
    <div className="col-md-6 mb-3">
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip">Select Job Title</Tooltip>}
  >
    <div>
      <Select
        options={jobPosts.map(job => ({
          value: job.jobPostID,
          label: `${job.title} - ${job.clientName}`,
        }))}
        value={
          jobPosts
            .map(job => ({
              value: job.jobPostID,
              label: `${job.title} - ${job.clientName}`,
            }))
            .find(opt => opt.value === (watch("jobPost") || selectedJobTitleId)) || null
        }
        onChange={(selected) => {
          const selectedOption = jobPosts.find(j => j.jobPostID === selected?.value);
          setValue("jobPost", selected?.value || "");
          setSelectedJobTitleId(selected?.value || "");
          if (selectedOption) {
            const normalizedBill = selectedOption.billRate?.replace(/[^0-9.]/g, "") || "";
            const normalizedPay = selectedOption.payRate?.replace(/[^0-9.]/g, "") || "";
            setValue("BillRate", normalizedBill);
            setValue("payRate", normalizedPay);
          }
        }}
        placeholder="Select Job Title"
        isDisabled={isViewMode}
        styles={{
          control: base => ({
            ...base,
            borderRadius: 15,
            height: 50,
            fontSize: 12,
          }),
        }}
      />
      {errors.jobPost && (
        <div className="invalid-feedback d-block">
          {errors.jobPost.message}
        </div>
      )}
    </div>
  </OverlayTrigger>
</div>


    <div className="col-md-6 mb-3">
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip-years">Years of Experience</Tooltip>}
  >
    <div className="d-flex gap-2">
      {/* Years Dropdown */}
      <select
        className={`form-control ${errors.experience ? "is-invalid" : ""}`}
         disabled={isViewMode}
        value={years}
        onChange={(e) => handleExperienceChange(e.target.value, months)}
        style={{ height: 50, width: "50%" }}
      >
        <option value="">Years</option>
        {[...Array(51).keys()].map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>

      {/* Months Dropdown */}
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="tooltip-months">Months of Experience</Tooltip>}
      >
        <select
          className={`form-control ${errors.experience ? "is-invalid" : ""}`}
          value={months}
           disabled={isViewMode}
          onChange={(e) => handleExperienceChange(years, e.target.value)}
          style={{ height: 50, width: "50%" }}
        >
          <option value="">Months</option>
          {[...Array(12).keys()].map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
      </OverlayTrigger>
    </div>
  </OverlayTrigger>
</div>
</div>
 <div className="row">

      <div className="col-md-6 mb-3">
        <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
              {selectedCountry == 2 ? "Bill Rate" : "Expected CTC"}
            </Tooltip>
          )}
        >
          <div>
            <input
             disabled={isViewMode}
              type={selectedCountry == 2 ? "number" : "text"}
              placeholder={selectedCountry == 2 ? "Bill Rate" : "Expected CTC"}
              {...register("BillRate")}
              id="BillRate"
              name="BillRate"
              className="form-control basic-form"
               onChange={(e) => {
          const input = e.target.value;
          // Only allow digits and optional Rs/$ prefix
          const cleaned = input.replace(/[^0-9.$Rs.]/gi, "");
          setValue("BillRate", cleaned);
        }}
            />
          </div>
        </OverlayTrigger>
      </div>

      <div className="col-md-6 mb-3">
        <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
             {selectedCountry == 2 ? "Pay Rate" : "Current CTC"}
            </Tooltip>
          )}
        >
          <div>
            <Form.Control
             disabled={isViewMode}
               type={selectedCountry == 2 ? "number" : "text"}
              placeholder={selectedCountry == 2 ? "Pay Rate" : "Current CTC"}
            className={`basic-form ${errors.payRate ? "is-invalid" : ""}`}
              {...register("payRate")}
               onChange={(e) => {
          const input = e.target.value;
          // Only allow digits and optional Rs/$ prefix
          const cleaned = input.replace(/[^0-9.$Rs]/gi, "");
          setValue("payRate", cleaned);
        }}
            />
          </div>
        </OverlayTrigger>
      </div>
</div>
 <div className="row">
      {/* ✅ Row 3: Work Mode, Key Skills, Profile Summary */}
      <div className="col-md-6 mb-3">
        <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
              Select Work Mode
            </Tooltip>
          )}
        >
          <div>
            <select
             disabled={isViewMode}
              {...register("workMode")}
              className={`form-control basic-form`}
              style={{ height: 50, borderRadius: 15 }}
            >
              <option value="">Select Work Mode</option>
              {workmode.map((item, index) => (
                <option key={index} value={item.statusName}>
                  {item.statusName}
                </option>
              ))}
            </select>
          </div>
        </OverlayTrigger>
      </div>

  
  <div className="col-md-6 mb-3">
        <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
              Select Client Status
            </Tooltip>
          )}
        >
          <div>
            <Form.Select {...register("clientStatus")} 
             disabled={isViewMode}
             style={{
                height: 50,
                borderRadius: 15,
                fontSize: 12,
                borderColor: errors.jobPost ? "red" : "",
              }}>
                  <option value="">Select Client Status</option>
                    <option value="New">New</option>
            <option value="Submitted">Submitted</option>
{/* <option value="In-Progress">In-Progress</option>
<option value="Interview Scheduled">Interview Scheduled</option>
<option value="On Hold">On-Hold</option>
<option value="Selected">Selected</option>
<option value="Rejected">Rejected</option> */}
            </Form.Select>
          </div>
        </OverlayTrigger>
      </div>
   </div>
 <div className="row">  
    <div className="col-md-6 mb-3">
        <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
              Key Skills
            </Tooltip>
          )}
        >
          <div>
            <textarea
             disabled={isViewMode}
              style={{ height: 100 }}
              {...register("technicalSkill")}
              placeholder="Enter Key Skills"
              className={`form-control basic-form mt-3`}
            />
          </div>
        </OverlayTrigger>
      </div>
       <div className="col-md-6 mb-3">
        <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
              Profile Summary
            </Tooltip>
          )}
        >
          <div>
            <textarea
             disabled={isViewMode}
              style={{ height: 100 }}
              placeholder="Profile Summary"
              {...register("ProfileSummery")}
              id="ProfileSummery"
              name="ProfileSummery"
              className="form-control basic-form mt-3"
            />
          </div>
        </OverlayTrigger>
      </div>
      </div>
 <div className="row">
          <div className="col-md-6 mb-3">
      <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">Custom Assessment Link</Tooltip>}>
  <input
    type="text"
    className="form-control mt-3"
    placeholder="Enter / Upload Custom Assessment"
    onClick={() => setShowAssessmentModal(true)}   // 👈 use onClick, not onFocus
      disabled={isViewMode}
    value={
      assessmentMode === "link"
        ? watch("customAssessmentLink")
        : assessmentMode === "file"
        ? (assessmentFile?.name || "")
        : ""
    }
  />
</OverlayTrigger>
</div>
         
      {/* <div className="col-md-6 mb-3">

                          <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Comments</Tooltip>)}>
                            <input type="text" name="Comments" {...register("Comments")} placeholder="Comments"
                              className={`form-control basic-form mt-3`} />
                          </OverlayTrigger>
                          </div> */}
                          <div className="col-md-6 mb-3">
                                   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Two References from Recent Project</Tooltip>)}>
                                                  <input type="text"disabled={isViewMode} title='' placeholder='Two References from Recent Project' {...register("Tworefrencesfromrecentproject")} id="Tworefrencesfromrecentproject" name="Tworefrencesfromrecentproject"
                                             className={`form-control basic-form mt-3 `}
                                                  />
                                                </OverlayTrigger>
</div>
</div>
 <div className="row">
       <div className="col-md-6 mb-3">
            <div class="mb-2 mt-4" style={{fontSize:12, color:"#495057"}}>
              <label >Willing to Relocate</label>
              </div>
          <input
  {...register("WillingToRelocate")}
  type="radio"
  name="WillingToRelocate"  // ✅ Correct
  value="Yes"
  id="WillingToRelocate"
  className="mr-2"
/>
<label style={{ fontSize: 13, color: "#495057" }}>Yes</label>

&nbsp;&nbsp;

<input
  {...register("WillingToRelocate")}
  type="radio"
  name="WillingToRelocate"  // ✅ Correct
  value="No"
  id="WillingToRelocateNo"
/>
<label style={{fontSize : 13, color:"#495057", marginLeft : 10}}>No</label>
    
       </div>
              <div className="col-md-6 mb-3">
                
                                     <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Availability to Interview</Tooltip>)}>  
                              <input type="text" title='' disabled={isViewMode} placeholder='Availability to Interview' {...register("AvailabilityToInterview")} id="AvailabilityToInterview" name="AvailabilityToInterview" 
                               className={`form-control basic-form mt-3 `}/>
                            </OverlayTrigger> 
              </div>
</div>
 <div className="row">
       <div className="col-md-6 mb-3">    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Availability for Joining</Tooltip>)}>  
                     <input type="text" title=''disabled={isViewMode} placeholder='Availability for Joining' {...register("AvailabilityToJoin")} id="AvailabilityToJoin" name="AvailabilityToJoin" 
                      className={`form-control basic-form mt-3 `}/>
                   </OverlayTrigger> </div>

 <div className="col-md-6 mb-3">
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id="tooltip">Select Submitted By</Tooltip>}
    >
      <div>
        <Select
          options={usersList.map((u) => ({
            value: u.email,
            label: u.fullName ? `${u.fullName} (${u.email})` : u.email,
          }))}
          isDisabled={isViewMode}
          value={
            usersList
              .map((u) => ({
                value: u.email,
                label: u.fullName
                  ? `${u.fullName} (${u.email})`
                  : u.email,
              }))
              .find(
                (opt) =>
                  opt.value === (watch("SubmittedBy") || submittedBy)
              ) || null
          }
          onChange={(selected) => {
            setValue("SubmittedBy", selected?.value || "");
            setSubmittedBy(selected?.value || "");
          }}
          styles={{
            control: (base) => ({
              ...base,
              height: "50px",
              minHeight: "50px",
              borderRadius: "15px",
              fontSize: "12px",
            }),
            valueContainer: (base) => ({
              ...base,
              paddingLeft: "12px",
            }),
          }}
        />
      </div>
    </OverlayTrigger>
  </div>
</div>
 
 <div className="row">
<div className="col-md-6 mb-3">
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">Candidate Type</Tooltip>}>
   <select  {...register("CandidateType")} className={`form-control `}style={{height:50 ,borderRadius:15,fontSize:12}} >
<option value="">Select Candidate Type</option>
{
  candidateType.map((item,index)=>
  {
    return(

   <option key={index}  value={item.candidateTypeID}>{item.candidateTypeID}</option>

    );
  }
  
  )
}
</select>
  </OverlayTrigger>
</div>
  
   {(isEditing || isViewMode) && (  
     <div className="col-md-6 mb-3">
  <label style={{ fontSize: 12 }}>Comments</label>

  <ReactQuill
    theme="snow"
    value={watch("Comments") || ""}
    onChange={(value) => setValue("Comments", DOMPurify.sanitize(value))}
    readOnly={isViewMode}   // disable editor when viewing
    style={{
      height: "150px",
      marginBottom: "40px",
      background: isViewMode ? "#f5f5f5" : "white",
      borderRadius: "8px"
    }}
  />
</div>
   )}
   </div>
 <div className="row">
      <div className="col-md-6 mb-3">
        <label className="" style={{ fontSize: "12px" }}>
          Upload Documents
        </label>
        <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
              Upload Documents
            </Tooltip>
          )}
        >
          <div>
          <Form.Select
  value={selectedDocType || ""}
   disabled={isViewMode}
  onChange={(e) => setSelectedDocType(e.target.value)}
   style={{
                height: 50,
                borderRadius: 15,
                fontSize: 12,
                borderColor: errors.jobPost ? "red" : "",
              }}
>
  <option value="">Select Any Document</option>
  {documents
       .map((doc, idx) => (
      <option key={idx} value={doc.documentType}>
        {doc.documentType}
      </option>
    ))}
          </Form.Select>
 

            {selectedDocType && (
              <div className="mt-1">
                <Form.Label htmlFor="uploadFile" className="fw-bold">
                  Attach {selectedDocType}
                </Form.Label>
             <Form.Control
  type="file"
  id="uploadFile"
  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
  disabled={isViewMode}
  onChange={(e) => {
    if (!e.target.files?.[0]) return;

    // 🔥 RESUME → extraction flow
    if (selectedDocType === "Resume") {
      handleResumeUploadWithChoice(e);
      return;
    }

    // ✅ OTHER DOCUMENTS → normal upload
    const file = e.target.files[0];
                    if (!file) return;

                    const updatedFiles = {
                      ...uploadedFiles,
                     [ docKeyMap[selectedDocType] ]: file

                    };
                    setUploadedFiles(updatedFiles);
                    e.target.value = "";
                    setSelectedDocType("");
                  }}
/>

              </div>
            )}

          <div className="mt-2">
  {Object.entries(docKeyMap).map(([label, key]) => {
    const file = uploadedFiles[key];
    if (!file || file === "__removed__") return null;

    const isFileObject = file instanceof File;
    const isString = typeof file === "string";

    const isInvalidString =
      isString &&
      (!file.trim() ||
        file.trim().toLowerCase() === "null" ||
        file.trim().toLowerCase() === "undefined" ||
        file.endsWith("/") ||
        file.endsWith("/null") ||
        file.endsWith("/undefined"));

    if (isInvalidString) return null;

    const displayLabel = label;  // clean UI label
    const fileName = isString ? file.split("/").pop() : file.name;
    const fileLink = isString ? file : URL.createObjectURL(file);

    return (
      <div key={key}>
        <strong style={{ fontSize: 12 }}>{displayLabel} :</strong>
        &nbsp;
        <span style={{ fontSize: 12 }}>{fileName}</span>&nbsp;|&nbsp;
        <button
          type="button"
          style={{
            border: "none",
            background: "transparent",
            color: "blue",
            fontSize: 12,
            cursor: "pointer",
          }}
          onClick={() => handleShowModal1(label, file)}
        >
          View
        </button>
        &nbsp; | &nbsp;
        <button
          type="button"
          style={{
            border: "none",
            background: "transparent",
            color: "red",
            fontSize: 12,
            cursor: "pointer",
          }}
          onClick={() => handleRemoveFile(label)}
        >
          Remove
        </button>
      </div>
    );
  })}
</div>

          </div>
        </OverlayTrigger>
      </div>
 <div className="col-md-6 mb-3">

<label className="" style={{ fontSize: "12px" }}>
  Skill Metrics
</label>
  {skills.map((skill, index) => {
  const hideDelete =
    skills.length === 0 || isEmptySkill(skill);

  return (
    <div key={index} className="d-flex gap-2 mb-2 align-items-center mt-2">
      
      <input
        type="text"
        className="form-control"
        placeholder="Skill"
        value={skill.Skill || ""}
        disabled={isViewMode}
        onChange={(e) => handleChange(index, "Skill", e.target.value)}
      />

      <input
        type="text"
        className="form-control"
        placeholder="No.of Years Exp"
        value={skill.YearsOfExp || ""}
        disabled={isViewMode}
        onChange={(e) => handleChange(index, "YearsOfExp", e.target.value)}
      />

      <input
        type="number"
        className="form-control"
        placeholder="Rating (1-5)"
        min="1"
        max="5"
        value={skill.Rating || ""}
        disabled={isViewMode}
        onChange={(e) => handleChange(index, "Rating", e.target.value)}
      />

      {/* ❌ Delete Button (conditionally hidden) */}
      {!isViewMode && !hideDelete && (
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => handleDelete(index)}
        >
          <i className="fa fa-trash"></i>
        </button>
      )}

      {/* ➕ Add Button only on last row */}
      {index === skills.length - 1 && !isViewMode && (
        <button
          type="button"
          className="btn btn-success"
          onClick={handleAdd}
        >
          <i className="fa fa-plus"></i>
        </button>
      )}
    </div>
  );
})}

      {/* Hidden input for API */}
      <input type="hidden" {...register("SkillMetrics")} />
      </div>

    </div>

    <div className="text-end mt-3">
     {!isViewMode && ( <Button type="submit" className="btn btn-success">
        <i className="fa fa-check mr-1"></i>
         {isEditing ? "Update" : "Submit"}
      </Button>
     )}
    </div>
 
  </Form>
  </>
    )}
</Modal.Body>

  </Modal>
  
  </Accordion.Body>
</Accordion.Item>
  

                  </Accordion>
                </div>
            ) : (
                <center><LoadingSpinner /></center>
            )}
<Modal show={showModal1} onHide={handleCloseModal1} size="lg" centered>
  <Modal.Header closeButton>
    <Modal.Title>{modalContent.title}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {renderAttachment(modalContent.url, modalContent.file, modalContent.html)}
  </Modal.Body>
</Modal>
<Modal show={showAssessmentModal} onHide={() => setShowAssessmentModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Custom Assessment Link</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {!assessmentMode && (
      <div className="d-flex flex-column gap-3">
        <button className="btn btn-outline-primary" onClick={() => setAssessmentMode("link")}>
          Enter Link Directly
        </button>
        <button className="btn btn-outline-secondary" onClick={() => setAssessmentMode("file")}>
          Upload File
        </button>
      </div>
    )}

    {assessmentMode === "link" && (
      <input
        type="text"
        className="form-control"
        placeholder="Enter Custom Assessment Link"
        {...register("customAssessmentLink")}
      />
    )}

    {assessmentMode === "file" && (
      <input
        type="file"
        accept="audio/*,.pdf,.doc,.docx,video/mp4,video/webm"
        className="form-control"
        onChange={(e) => setAssessmentFile(e.target.files[0])}
      />
    )}
  </Modal.Body>
  <Modal.Footer>
    <button className="btn btn-secondary" onClick={() => {
      setAssessmentMode("");
      setShowAssessmentModal(false);
    }}>
      Close
    </button>
    <button className="btn btn-primary" onClick={() => setShowAssessmentModal(false)}>
      Done
    </button>
  </Modal.Footer>
</Modal>
{/* upload document modal */}

<Modal
  show={showExtractModal}
  onHide={() => setShowExtractModal(false)}
  size="lg"
  backdrop="static"
>
  {/* extracted resume data modal */}
  <Modal.Header closeButton>
    <Modal.Title>Select Extracted Resume Details</Modal.Title>
  </Modal.Header>

<Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>

  {isExtractingResume ? (
    /* 🔄 Loader while extracting */
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 150 }}>
      <Spinner animation="border" variant="info" />
      <p className="mt-3">
        Extracting resume details, please wait...
      </p>
    </div>
  ) : (
    <>
      {/* ✅ Select All */}
      <div className="mb-3">
        <label style={{ fontWeight: 600 }}>
          <input
            type="checkbox"
            checked={Object.values(selectedFields).every(Boolean)}
            onChange={(e) => toggleSelectAll(e.target.checked)}
            style={{ marginRight: 8 }}
          />
          Select All
        </label>
      </div>

      <FieldRow
        label="Skills"
        value={extractedData?.skills}
        checked={selectedFields.skills}
        onChange={() => toggleField("skills")}
      />

      <FieldRow
        label="Experience"
        value={extractedData?.experience}
        checked={selectedFields.experience}
        onChange={() => toggleField("experience")}
      />

      <FieldRow
        label="Profile Summary"
        value={extractedData?.profilesummary}
        checked={selectedFields.profilesummary}
        onChange={() => toggleField("profilesummary")}
      />
    </>
  )}
</Modal.Body>
  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setShowExtractModal(false)}
    >
      Cancel
    </Button>

    <Button
      variant="primary"
      onClick={applySelectedExtractedData}
    >
      Apply Selected
    </Button>
  </Modal.Footer>
</Modal>

{/* ===============================
   🧠 Extracted Resume Data Modal
   =============================== */}

        </ConsultantLayout>
    );
};

export default ViewCandidateDetailsByCandidateGUid;
